import { render, staticRenderFns } from "./Forbes.vue?vue&type=template&id=fdcc13be&scoped=true"
import script from "./Forbes.vue?vue&type=script&lang=js"
export * from "./Forbes.vue?vue&type=script&lang=js"
import style0 from "./Forbes.vue?vue&type=style&index=0&id=fdcc13be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdcc13be",
  null
  
)

export default component.exports